import { LanguageService } from '@services/LanguageService';

export default class LangSelectionPlugin {
  dom: HTMLElement;

  constructor(dom: HTMLElement) {
    this.dom = dom;
  }

  init() {
    const buttons = this.dom.querySelectorAll<HTMLElement>('.langSelection');

    buttons.forEach((btn) =>
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const lang = btn.dataset.langid;
        LanguageService.cookieLanguage = lang;
        LanguageService.urlLanguage = lang;
      }),
    );
  }
}
